import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-798e8e2f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0,
  class: "cont_item_remarks"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {
    "float": "left"
  }
}, "卖家备注：", -1));
const _hoisted_5 = {
  style: {
    "float": "left",
    "white-space": "wrap"
  }
};
const _hoisted_6 = {
  class: "cont_item"
};
const _hoisted_7 = {
  class: "center borderBottom"
};
const _hoisted_8 = ["onUpdate:modelValue"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-transporttruck"
}, null, -1));
const _hoisted_10 = ["onClick", "copyData"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "iconfont",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-copy"
})], -1));
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  key: 1,
  class: "cont_item"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "info"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-transporttruck"
}, null, -1));
const _hoisted_17 = {
  class: "time"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-next"
})], -1));
const _hoisted_19 = {
  key: 2,
  class: "cont_item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "center borderBottom"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-transporttruck"
}), /*#__PURE__*/_createTextVNode("暂无信息 ")])], -1));
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = {
  key: 3,
  class: "img-box"
};
const _hoisted_23 = {
  class: "img"
};
const _hoisted_24 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['logistics_list', 'render-hide-scroll', {
      'app': $data.env.isModianIos() || $data.env.isModianAndroid() || $data.env.isModianIosNew()
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.logistics_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "logistics_item logistics_item_1",
      key: index
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("strong", null, _toDisplayString(item.title), 1), item.deliver_time ? (_openBlock(), _createElementBlock("em", _hoisted_2, _toDisplayString(item.deliver_time), 1)) : _createCommentVNode("", true)]), item.remarks ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(item.remarks), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
      type: "hidden",
      "onUpdate:modelValue": $event => item.express_no = $event
    }, null, 8, _hoisted_8), [[_vModelText, item.express_no]]), _createElementVNode("p", null, [_hoisted_9, _createTextVNode(" " + _toDisplayString(item.express_company) + ": " + _toDisplayString(item.express_no) + " ", 1), _createElementVNode("span", {
      class: "copy",
      onClick: _withModifiers($event => $options.copy(index), ["stop"]),
      ref_for: true,
      ref: "copyboard",
      copyData: item.express_no
    }, _hoisted_12, 8, _hoisted_10)])])]), item.logistics_info && item.logistics_info.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
      class: "center borderBottom",
      onClick: _withModifiers($event => $options.goDetail(item.express_company, item.express_no), ["stop"])
    }, [_createElementVNode("p", _hoisted_15, [_hoisted_16, _createTextVNode(" " + _toDisplayString(item.logistics_info[item.logistics_info.length - 1].status), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(item.logistics_info[item.logistics_info.length - 1].time), 1), _hoisted_18], 8, _hoisted_14)])) : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)), item.img_url ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
      src: item.img_url
    }, null, 8, _hoisted_24)])])) : _createCommentVNode("", true)]);
  }), 128))], 2));
}